<template>
  <div>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
      <v-layout align-center pr-4>
        <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
        <v-layout column>
          <div>
            <strong v-html="snackbar.title"></strong>
          </div>
          <div v-html="snackbar.text"></div>
        </v-layout>
      </v-layout>
      <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
    <MeasurementsTable></MeasurementsTable>
  </div>
</template>

<script>

import MeasurementsTable from "./MeasurementsTable";
import eventBus from "../../../event-bus/eventBus";
import downloadFileHelper from "../../../helpers/downloadFileHelper";

export default {
  name: "MeasurementsRelation",
  components: {MeasurementsTable},
  data() {
    return {
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: null,
        text: null,
        corner: null,
        timeout: 7500,
        title: null,
        visible: false
      },
    }
  },
  methods: {
    getSnackBar: function(title, message, icon, color) {
      this.snackbar = {
        color: color,
        icon: icon,
        mode: "multi-line",
        position: "top",
        corner: 'right',
        title: title,
        text: message,
        visible: true
      };
    },
  },
  mounted() {
    eventBus.$on("generateMeasurementPdfSuccess", (data) => {
      downloadFileHelper(data);
      this.getSnackBar(data.message, data.data.textInfo, "check_circle", "success");
      eventBus.$emit('filterDocuments');
    });

    eventBus.$on("storeMeasurementAndGeneratePdfSuccess", (data) => {
      downloadFileHelper(data);
      eventBus.$emit('filterDocuments');
    });

    eventBus.$on("generateMeasurementPdfFailure", (data) => {
      downloadFileHelper(data);
      this.getSnackBar(data.message, data.data.textInfo, "error", "failure");
    });
  },
  beforeDestroy() {
    eventBus.$off('generateMeasurementPdfSuccess')
  }


}

</script>
